export const languageOptions = [
  {
    code: 'en',
    label: 'English',
    nativeName: 'English',
    flag: '🇬🇧',
    flagCode: 'gb',
  },
  {
    code: 'fr',
    label: 'French',
    nativeName: 'Français',
    flag: '🇫🇷',
    flagCode: 'fr',
  },
  {
    code: 'es',
    label: 'Spanish',
    nativeName: 'Español',
    flag: '🇪🇸',
    flagCode: 'es',
  },
  {
    code: 'ar',
    label: 'Arabic',
    nativeName: 'العربية',
    flag: '🇸🇦',
    flagCode: 'sa',
  },
  {
    code: 'pt',
    label: 'Portuguese',
    nativeName: 'Português',
    flag: '🇧🇷',
    flagCode: 'br',
  },
  {
    code: 'hi',
    label: 'Hindi',
    nativeName: 'हिन्दी',
    flag: '🇮🇳',
    flagCode: 'in',
  },
  {
    code: 'zh',
    label: 'Chinese',
    nativeName: '中文',
    flag: '🇨🇳',
    flagCode: 'cn',
  },
  {
    code: 'id',
    label: 'Indonesian',
    nativeName: 'Bahasa',
    flag: '🇮🇩',
    flagCode: 'id',
  },
  {
    code: 'ru',
    label: 'Russian',
    nativeName: 'Русский',
    flag: '🇷🇺',
    flagCode: 'ru',
  },
  {
    code: 'sw',
    label: 'Kiswahili',
    nativeName: 'Kiswahili',
    flag: '🇰🇪',
    flagCode: 'ke',
  },
] as const;

export type LanguageCode = (typeof languageOptions)[number]['code'];
export type LocaleResource = Record<string, unknown>;
